'use client';
import { anatomy } from '@zag-js/checkbox';

const checkboxAnatomy = anatomy.extendWith("group");

export { checkboxAnatomy };
